// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".empty-wrapper[data-v-3fcbfa26]{\n  margin:var(--space-zero) auto\n}", "",{"version":3,"sources":["/app/app/javascript/dashboard/routes/dashboard/settings/integrationapps/Index.vue"],"names":[],"mappings":"AAoDA;EACE;AAAA","file":"Index.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import '~dashboard/assets/scss/variables';\n.empty-wrapper {\n  margin: var(--space-zero) auto;\n}\n"]}]);
// Exports
module.exports = exports;
